import type { SerializedReseller } from '@enmon/commons/lib/tools';
import { gql } from '@apollo/client';

export const GET_ESSENTIAL_RESELLERS_DATA = gql`
  query {
    resellers {
      data {
        id
        attributes {
          name
          enmon_customer_id
        }
      }
    }
  }
`;

export type EssentialResellersDataItem = Pick<SerializedReseller, 'id' | 'name' | 'enmon_customer_id'>;

export interface EssentialResellersData {
  resellers: {
    data: EssentialResellersDataItem[];
  };
}
